export const DOCUMENT_CATEGORIES = [
  {
    value: "3",
    label: "Surat Keterangan",
  },
  {
    value: "4a",
    label: "Dokumen penerimaan uang (lebih dari 5 juta)",
  },
  {
    value: "3",
    label: "Surat Lainnya",
  },
  {
    value: "3",
    label: "Surat Pernyataan",
  },
  {
    value: "2",
    label: "Dokumen Transaksi",
  },
  {
    value: "4b",
    label: "Dokumen pelunasan utang (lebih dari 5 juta)",
  },
  {
    value: "2",
    label: "Surat Berharga",
  },
  {
    value: "2",
    label: "Akta Pejabat",
  },
  {
    value: "2",
    label: "Dokumen lain-lain",
  },
  {
    value: "2",
    label: "Akta Notaris",
  },
  {
    value: "2",
    label: "Dokumen Lelang",
  },
  {
    value: "3",
    label: "Surat Perjanjian",
  },
  {
    value: "4a",
    label: "Dokumen pernyataan jumlah uang lebih dari 5jt",
  },
];

export const SEARCH_CATEGORY = [
  {
    value: "SERIAL_NUMBER",
    label: "Search By Serial Number",
  },
  {
    value: "FILE_NAME",
    label: "Search By File Name",
  },
  {
    value: "FILE_TYPE",
    label: "Search By File Type",
  },
];

export const DOCUMENT_STATUS = [
  {
    value: "ALL",
    label: "All",
  },
  {
    value: "SUCCESS",
    label: "Success",
  },
  {
    value: "PENDING",
    label: "Pending",
  },
  {
    value: "FAILED",
    label: "Failed",
  },
];
